import React from "react";
import { Toggle } from "../../../../../../components";
import { FORM_KEYS } from "../../../../constants";

/**
 * @desc Toggle public mode for mondo conventions.
 */
export const TogglePublicMondo = (props) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "form-public-mondo-error",
  };

  const inputProps = {
    id: "toggle-public-mondo",
    className: "form-control",
    "aria-describedby": errorProps.id,
    ...props,
  };

  const labelProps = {
    className: "switch form-control-label",
    htmlFor: inputProps.id,
    children: "SET TO PUBLIC - MONDO",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.IS_PUBLIC_MONDO,
  };

  return <Toggle {...parentProps} />;
};
